const config = {
  keys: {
    gCaptcha: '6Ld065onAAAAALey66jWopEXpXpVt9qdhiv1939X',
    rollbar: '428b350ad59e4bb0893fe3be03218ecf',
    gAnalytics: 'G-5YK9LQN31J',
  },
};

export default config;
